/**
 * /about - "Software and support dates" for the Risk Management panel (0.22.0).
 *
 * This panel's own packages (embedded at build time) plus pcb-retail-api's live
 * GET /api/health/about. Contract: docs/standards/about-dependencies-contract.md.
 */

import { useMemo } from 'react';
import { AboutDependencies, type AboutBackend } from '@retail-ops/about-panel';
import { useApiClient } from '@/contexts/ApiClientContext';
import { APP_NAME, APP_VERSION } from '@/constants/version';

export function AboutPage(): JSX.Element {
  const client = useApiClient();
  const backends = useMemo<AboutBackend[]>(
    () => [{ label: 'Server: pcb-retail-api', load: () => client.health.about() }],
    [client],
  );
  return (
    <div className="pcb-about-page">
      <h2 className="pcb-about-page__title">About {APP_NAME}</h2>
      <p className="pcb-about-page__intro">
        Version {APP_VERSION}. Every piece of software this panel and its server run, with the date its
        publisher stops supporting it.
      </p>
      <AboutDependencies backends={backends} />
    </div>
  );
}

export default AboutPage;
